import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modals } from '../../../common/enum';
import { selectModalState, selectModalStateByName } from '../../../services/controllers/common/CommonSelector';
import { toggleModals } from '../../../services/controllers/common/CommonSlice';
import { useDeleteFormulaActivityMutation } from '../../../services/controllers/formula/FormulaQueries';
import { FormulaActivityAttributes } from '../../../services/types/apiType';

const DeleteFormulaActivity: React.FC = () => {
  const dispatch = useDispatch();

  const isOpen = useSelector(selectModalStateByName(Modals.DELETE_FORMULA_ACTIVITY));
  const selectedData: FormulaActivityAttributes = useSelector(selectModalState);

  const { mutate: deleteMutate, isLoading: deleteLoading } = useDeleteFormulaActivityMutation();

  const onClose = () => {
    dispatch(toggleModals({ name: Modals.DELETE_FORMULA_ACTIVITY }));
  };

  const onSubmit = async () => {
    if (!selectedData?.id) return;

    deleteMutate(selectedData.id, {
      onSuccess: () => {
        onClose();
      },
    });
  };

  if (!selectedData) return null;

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Xoá hoạt động</DialogTitle>
      <DialogContent>
        <Typography>Bạn có chắc chắn muốn xoá hoạt động này? Các chất đã sử dụng sẽ được thêm lại vào kho.</Typography>
      </DialogContent>
      <DialogActions>
        <Button disabled={deleteLoading} variant="outlined" onClick={onClose}>
          Huỷ bỏ
        </Button>
        <Button disabled={deleteLoading} variant="contained" onClick={onSubmit}>
          Xoá
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteFormulaActivity;
